var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('input',{ref:"fileInput",attrs:{"type":"file","hidden":""},on:{"change":_vm.upload}}),_c('button',{staticClass:"btn btn-primary btn-extra-round",on:{"click":function($event){return _vm.$refs.fileInput.click()}}},[_vm._v("\n      Auto Config\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }